<template>
    <div class="container-fluid" style="padding-right: 0px; padding-left: 0px; padding-top: 60px; padding-bottom: 20px;">
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <div class="container">
            <div class="contact__wrapper shadow-lg mt-4 mt-n9 mb-n9">
                <div class="row no-gutters">
                    <div class="col-lg-5 contact-info__wrapper gradient-brand-color p-5 order-lg-2">
                        <h3 class="color--white mb-5">Contact Us</h3>
                        <ul class="contact-info__list list-style--none position-relative z-index-101">
                            <li class="mb-4 pl-4">
                                <span class="position-absolute"><i class="fas fa-envelope"></i></span> {{ siteDatas.supportCMS.email }}
                            </li>
                            <li class="mb-4 pl-4">
                                <span class="position-absolute"><i class="fas fa-phone"></i></span> {{ siteDatas.supportCMS.phone }}
                            </li>
                            <li class="mb-4 pl-4">
                                <span class="position-absolute"><i class="fas fa-map-marker-alt"></i></span> {{ siteDatas.supportCMS.address }}
                                <div class="mt-3">
                                    <a :href="siteDatas.supportCMS.map_url" target="_blank" class="text-link link--right-icon text-white"><i class="link__icon fa fa-directions"></i> Google Map</a>
                                </div>
                            </li>
                        </ul>
                        <figure class="figure position-absolute m-0 opacity-06 z-index-100" style="bottom: 0px; right: 10px">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="444px" height="626px">
                                <defs>
                                    <linearGradient id="PSgrad_1" x1="0%" x2="81.915%" y1="57.358%" y2="0%">
                                        <stop offset="0%" stop-color="rgb(42, 124, 39)" stop-opacity="1"></stop>
                                        <stop offset="100%" stop-color="rgb(42, 124, 39)" stop-opacity="0"></stop>
                                    </linearGradient>
                                </defs>
                                <path fill-rule="evenodd" opacity="0.302" fill="rgb(42, 124, 39)"
                                    d="M816.210,-41.714 L968.999,111.158 L-197.210,1277.998 L-349.998,1125.127 L816.210,-41.714 Z">
                                </path>
                                <path fill="url(#PSgrad_1)"
                                    d="M816.210,-41.714 L968.999,111.158 L-197.210,1277.998 L-349.998,1125.127 L816.210,-41.714 Z">
                                </path>
                            </svg>
                        </figure>
                    </div>
                    <div class="col-lg-7 contact-form__wrapper p-5 order-lg-1">
                        <form @submit.prevent="submit" class="contact-form form-validate" novalidate="novalidate">
                            <div class="row">
                                <div class="col-sm-12 mb-3">
                                    <div class="form-group">
                                        <label class="required-field" for="firstName">Full Name</label>
                                        <input type="text" class="form-control" v-model="name" id="firstName" name="firstName" placeholder="">
                                    </div>
                                </div>

                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label class="required-field" for="email">Email</label>
                                        <input type="text" class="form-control" v-model="email" id="email" name="email" placeholder="">
                                    </div>
                                </div>

                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label for="phone">Phone</label>
                                        <input type="tel" class="form-control" v-model="contact" id="phone" name="phone" placeholder="">
                                    </div>
                                </div>

                                <div class="col-sm-12 mb-3">
                                    <div class="form-group">
                                        <label class="required-field" for="message">Message</label>
                                        <textarea class="form-control" v-model="comments" id="message" name="message" rows="4" placeholder=""></textarea>
                                    </div>
                                </div>

                                <div class="col-sm-12 mb-3">
                                    <button type="submit" name="submit" class="btn button success shadow">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
    name: "SupportComponent",
    components: {
        Loading
    },
    props: ['siteDatas'],
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            name: "",
            email: "",
            contact: "",
            comments: ""
        }
    },
    methods: {
        submit: function() {
            this.isLoading = true;
            const data = {
                name: this.name,
                email: this.email,
                contact: this.contact,
                comments: this.comments
            };
            console.log(data);
            var config = {
                method: "POST",
                url: this.$api + this.$config.support.storeSupportURL,
                data: data
            };
            this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    this.$swal.fire({
                        icon: "success",
                        text: "Successfully stored data!"
                    });
                    this.name = '';
                    this.email = '';
                    this.contact = '';
                    this.comments = '';
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        }
    }
}
</script>

<style src="./css/common.css"></style>

<style scoped>
body {
    margin-top: 20px;
    background: #eee;
}

.gradient-brand-color {
    background-image: -webkit-linear-gradient(0deg, #02b514 0%, #2a7c27 100%);
    background-image: -ms-linear-gradient(0deg, #02b514 0%, #2a7c27 100%);
    color: #fff;
}

.contact-info__wrapper {
    overflow: hidden;
    border-radius: .625rem .625rem 0 0
}

@media (min-width: 1024px) {
    .contact-info__wrapper {
        border-radius: 0 .625rem .625rem 0;
        padding: 5rem !important
    }
}

.contact-info__list span.position-absolute {
    left: 0
}

.z-index-101 {
    z-index: 101;
}

.list-style--none {
    list-style: none;
}

.contact__wrapper {
    background-color: #fff;
    border-radius: 0 0 .625rem .625rem
}

@media (min-width: 1024px) {
    .contact__wrapper {
        border-radius: .625rem 0 .625rem .625rem
    }
}

@media (min-width: 1024px) {
    .contact-form__wrapper {
        padding: 5rem !important
    }
}

.shadow-lg {
    box-shadow: 0 1rem 3rem rgba(132, 138, 163, 0.1) !important;
}
</style>
